import request from '@/utils/request'

export function getShopInfo() {
  return request({
    url: '/system/shopInfo/getInfoByDomainName',
      method: 'get',
      params: {
        domainName: window.location.host
        // domainName: 'qy.hu0tao.com'
      }
  })
}

// 登录方法
export function login(data) {
  return request({
    url: '/pwApi/pwLogin?name=' + data.name + '&pwd=' + data.pwd,
    method: 'post'
  })
}

// 获取用户信息
export function getPwInfo(data) {
  return request({
    url: '/pwApi/getPwInfo?token=' + data,
    method: 'get'
  })
}

// 获取业务列表
export function listOrderType() {
  return request({
    url: '/system/orderType/getList',
    method: 'get'
  })
}

// 获取客服列表
export function listKf() {
  return request({
    url: '/system/kf/getList',
    method: 'get'
  })
}

// 获取二级业务
export function getChildBusinessByParentIdAndPrice(query) {
  return request({
    url: '/system/orderType/getInfoByParentIdAndPrice',
    method: 'get',
    params: query
  })
}

// 获取老板信息
export function getBossInfoByName(query) {
  return request({
    url: '/system/boss/getBossInfoByName',
    method: 'get',
    params: query,
    isNotShowMsg: true
  })
}

// 提交订单
export function saveOrder(data) {
  return request({
    url: '/system/order/save',
    method: 'post',
    data: data,
    isNotShowMsg: true
  })
}

// 获取陪玩订单列表
export function listPwOrder(query) {
  return request({
    url: '/pwApi/selectPwOrderByPassword',
    method: 'get',
    params: query
  })
}

// 修改陪玩信息
export function updatePw(token, data) {
  return request({
    url: '/pwApi/updatePwInfoByToken/' + token,
    method: 'post',
    data: data
  })
}

// 修改陪玩密码
export function updatePsw(token, data) {
  return request({
    url: '/pwApi/updatePwPasswordByToken/' + token,
    method: 'post',
    data: data
  })
}

